import type { ListStatusFragment } from './ListStatusFragment.generated';
import { useListStatusFragment } from './ListStatusFragment.generated';

export type ListStatus = NonNullable<ListStatusFragment['status']>;

interface HookProps {
  idList: string;
  skip?: boolean;
}

export const useListStatus = ({
  idList,
  skip,
}: HookProps): ListStatus | null => {
  const { data: list } = useListStatusFragment({
    from: { id: idList },
    optimistic: true,
  });

  return skip ? null : list?.status ?? null;
};
